import { readRmsDomains } from '@racepointenergy/swc/scs/read-rms-domains'

import { PERMISSIONS_POLLING_INTERVAL } from 'app/consts'

// get User Top Domains data without subdomains
// for root user it will be his root domains
// for subdomain user it will be his top subdomains in domains tree
function useUserTopDomains(currentRootDomainId: string | undefined) {
  const {
    data: userTopDomainsData,
    error,
    isError,
    isFetching,
    isSuccess,
  } = readRmsDomains.useQuery(
    { rootdomainid: currentRootDomainId, users: 'self', depth: 0, jobs: true },
    {
      skip: !currentRootDomainId,
      pollingInterval: PERMISSIONS_POLLING_INTERVAL,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
    }
  )

  return { userTopDomainsData, error, isError, isFetching, isSuccess }
}

export default useUserTopDomains
